import EventBillModel from './event_bill_model';
export default Backbone.Collection.extend({
  model: EventBillModel
});